// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/container/v1/service.proto (package chalk.container.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { CustomClaim } from "../../auth/v1/agent_pb";
import { file_chalk_auth_v1_agent } from "../../auth/v1/agent_pb";
import type { FeaturePermissions } from "../../auth/v1/featurepermission_pb";
import { file_chalk_auth_v1_featurepermission } from "../../auth/v1/featurepermission_pb";
import type { Permission } from "../../auth/v1/permissions_pb";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { SnapshotCompatibilityRequirements } from "./snapshot_compatibility_pb";
import { file_chalk_container_v1_snapshot_compatibility } from "./snapshot_compatibility_pb";
import { file_chalk_flags_v1_flags } from "../../flags/v1/flags_pb";
import type { Duration, Empty, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/container/v1/service.proto.
 */
export const file_chalk_container_v1_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_auth_v1_agent, file_chalk_auth_v1_featurepermission, file_chalk_auth_v1_permissions, file_chalk_container_v1_snapshot_compatibility, file_chalk_flags_v1_flags, file_google_protobuf_duration, file_google_protobuf_empty, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.container.v1.ResourceLimits
 */
export type ResourceLimits = Message<"chalk.container.v1.ResourceLimits"> & {
  /**
   * CPU limit, e.g., "2" or "500m"
   *
   * @generated from field: optional string cpu = 1;
   */
  cpu?: string;

  /**
   * Memory limit, e.g., "4Gi" or "512Mi"
   *
   * @generated from field: optional string memory = 2;
   */
  memory?: string;

  /**
   * GPU request: "type:count" (e.g., "nvidia-tesla-t4:1", "h100:2"),
   * "type" (e.g., "h100", implies count of 1), or "count" (e.g., "1")
   *
   * @generated from field: optional string gpu = 3;
   */
  gpu?: string;
};

/**
 * Describes the message chalk.container.v1.ResourceLimits.
 * Use `create(ResourceLimitsSchema)` to create a new message.
 */
export const ResourceLimitsSchema: GenMessage<ResourceLimits> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 0);

/**
 * VolumeMount describes a volume to mount into a container
 *
 * @generated from message chalk.container.v1.VolumeMount
 */
export type VolumeMount = Message<"chalk.container.v1.VolumeMount"> & {
  /**
   * Name of the volume (used for identification)
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Path inside the container where the volume should be mounted
   *
   * @generated from field: string mount_path = 2;
   */
  mountPath: string;

  /**
   * Type of volume: "empty_dir", "shared_memory", or "versioned_chalkfs".
   *
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * Size limit for the volume (e.g., "2Gi"). Optional for empty_dir: when omitted
   * or zero the platform applies a configured default cap. Used by shared_memory.
   *
   * @generated from field: optional string size_limit = 4;
   */
  sizeLimit?: string;

  /**
   * Pins a "versioned_chalkfs" mount to an immutable committed snapshot and
   * stages writes locally without committing.
   *
   * @generated from field: optional uint64 version_id = 5;
   */
  versionId?: bigint;

  /**
   * Selects an existing mutable ref for a "versioned_chalkfs" mount.
   * Mutually exclusive with version_id.
   *
   * @generated from field: optional string ref_name = 6;
   */
  refName?: string;
};

/**
 * Describes the message chalk.container.v1.VolumeMount.
 * Use `create(VolumeMountSchema)` to create a new message.
 */
export const VolumeMountSchema: GenMessage<VolumeMount> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 1);

/**
 * SecretRef references an integration or standalone secret to inject as env vars.
 *
 * @generated from message chalk.container.v1.SecretRef
 */
export type SecretRef = Message<"chalk.container.v1.SecretRef"> & {
  /**
   * @generated from oneof chalk.container.v1.SecretRef.source
   */
  source: {
    /**
     * Reference an integration by name (e.g. "prod_postgres").
     * All secrets associated with the integration are injected as env vars.
     *
     * @generated from field: string integration_name = 1;
     */
    value: string;
    case: "integrationName";
  } | {
    /**
     * Reference a standalone secret by name (e.g. "OPENAI_API_TOKEN").
     *
     * @generated from field: string secret_name = 2;
     */
    value: string;
    case: "secretName";
  } | { case: undefined; value?: undefined };

  /**
   * Only inject these specific keys from an integration.
   * Ignored for standalone secrets. Empty means "inject all".
   *
   * @generated from field: repeated string keys = 3;
   */
  keys: string[];

  /**
   * Remap env var names. Key = original name, value = desired env var name.
   * e.g. {"PGHOST": "DATABASE_HOST"} or {"OPENAI_API_TOKEN": "API_KEY"}
   *
   * @generated from field: map<string, string> aliases = 4;
   */
  aliases: { [key: string]: string };

  /**
   * Inject all vars under a common prefix (e.g. prefix="PG_" turns HOST into PG_HOST).
   *
   * @generated from field: optional string prefix = 5;
   */
  prefix?: string;
};

/**
 * Describes the message chalk.container.v1.SecretRef.
 * Use `create(SecretRefSchema)` to create a new message.
 */
export const SecretRefSchema: GenMessage<SecretRef> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 2);

/**
 * @generated from message chalk.container.v1.ManagedSshDestination
 */
export type ManagedSshDestination = Message<"chalk.container.v1.ManagedSshDestination"> & {
  /**
   * DNS hostname or IP address authorized for SSH and used as HostName.
   *
   * @generated from field: string host = 1;
   */
  host: string;

  /**
   * Chalk Secret name containing the private key. The public spec stores only
   * this name; the private-key plaintext is never stored here.
   *
   * @generated from field: string private_key_secret = 2;
   */
  privateKeySecret: string;

  /**
   * SSH host key entries. Empty uses trust on first use for the sandbox lifetime.
   *
   * @generated from field: repeated string host_keys = 3;
   */
  hostKeys: string[];

  /**
   * SSH destination port. Defaults to 22 when omitted.
   *
   * @generated from field: optional uint32 port = 4;
   */
  port?: number;

  /**
   * Optional SSH username written to the generated alias's User setting.
   *
   * @generated from field: optional string username = 5;
   */
  username?: string;
};

/**
 * Describes the message chalk.container.v1.ManagedSshDestination.
 * Use `create(ManagedSshDestinationSchema)` to create a new message.
 */
export const ManagedSshDestinationSchema: GenMessage<ManagedSshDestination> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 3);

/**
 * ChalkContainerSpec contains the immutable specification of what to run
 *
 * @generated from message chalk.container.v1.ChalkContainerSpec
 */
export type ChalkContainerSpec = Message<"chalk.container.v1.ChalkContainerSpec"> & {
  /**
   * Unique name for the container (unique per environment)
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The Docker image to run
   *
   * @generated from field: string image = 2;
   */
  image: string;

  /**
   * The entrypoint command and arguments
   *
   * @generated from field: repeated string entrypoint = 3;
   */
  entrypoint: string[];

  /**
   * User-defined tags (key-value pairs)
   *
   * @generated from field: map<string, string> tags = 4;
   */
  tags: { [key: string]: string };

  /**
   * Optional port to expose from the main container
   *
   * @generated from field: optional int32 port = 5;
   */
  port?: number;

  /**
   * How long the container should run before being terminated
   * A value of 0 means no relative execution limit. Group expiry independently
   * terminates the workload at an absolute deadline, including provisioning time.
   *
   * @generated from field: optional google.protobuf.Duration lifetime = 6;
   */
  lifetime?: Duration;

  /**
   * Optional resource limits for CPU and memory
   *
   * @generated from field: optional chalk.container.v1.ResourceLimits resources = 7;
   */
  resources?: ResourceLimits;

  /**
   * Deprecated: inbound SSH access to running containers is no longer supported.
   *
   * @generated from field: optional bool enable_ssh = 8 [deprecated = true];
   * @deprecated
   */
  enableSsh?: boolean;

  /**
   * Environment variables to inject into the container
   *
   * @generated from field: map<string, string> env_vars = 9;
   */
  envVars: { [key: string]: string };

  /**
   * Volumes to mount into the container
   *
   * @generated from field: repeated chalk.container.v1.VolumeMount volumes = 10;
   */
  volumes: VolumeMount[];

  /**
   * Protocol the backend speaks: "http" (default) or "grpc".
   *
   * @generated from field: optional string protocol = 11;
   */
  protocol?: string;

  /**
   * The routing mode for the container (defaults to PUBLIC)
   *
   * PUBLIC, PRIVATE
   *
   * @generated from field: optional string routing = 12;
   */
  routing?: string;

  /**
   * Authentication mode for the container's HTTP route (defaults to UNAUTHENTICATED)
   * When set to AUTHENTICATED, creates an Envoy Gateway SecurityPolicy with JWT validation
   *
   * UNAUTHENTICATED, AUTHENTICATED
   *
   * @generated from field: optional string authentication = 13;
   */
  authentication?: string;

  /**
   * References to integrations or standalone secrets whose values should be
   * injected as environment variables into the container.
   *
   * @generated from field: repeated chalk.container.v1.SecretRef secret_refs = 14;
   */
  secretRefs: SecretRef[];

  /**
   * Security policy settings for the container
   * A missing or nil policy is fully unrestricted, for backwards compatibility
   * An empty (but non-nil) policy means fully restricted settings
   *
   * @generated from field: optional chalk.container.v1.ContainerSecurityPolicy security_policy = 15;
   */
  securityPolicy?: ContainerSecurityPolicy;

  /**
   * Network security settings for the container.
   * For HOST containers, missing, nil, and empty policies are equivalent:
   * application egress is denied unless allowed routes or hosts are configured.
   *
   * @generated from field: optional chalk.container.v1.NetworkPolicy network_policy = 16;
   */
  networkPolicy?: NetworkPolicy;

  /**
   * Where to run the container. Defaults to K8S (a Kubernetes pod).
   *
   * @generated from field: optional chalk.container.v1.ComputeClass compute_class = 17;
   */
  computeClass?: ComputeClass;

  /**
   * Optional externally-routed startup probe. When set, the workload remains
   * Pending until a request to its configured hostname succeeds. Requires port
   * to be set. Defaults differ by protocol (see StartupProbe -> HttpProbe/GrpcProbe).
   * Supported for containers and scaling groups. For AUTHENTICATED routes,
   * the controller sends a working token scoped to PERMISSION_AUTHENTICATED.
   *
   * @generated from field: optional chalk.container.v1.StartupProbe startup_probe = 18;
   */
  startupProbe?: StartupProbe;

  /**
   * Optional continuous readiness probe. Supported only for scaling groups currently.
   *
   * @generated from field: optional chalk.container.v1.ReadinessProbe readiness_probe = 19;
   */
  readinessProbe?: ReadinessProbe;

  /**
   * Whether to recreate the container after its backing instance terminates.
   *
   * @generated from field: optional chalk.container.v1.RestartPolicy restart_policy = 20;
   */
  restartPolicy?: RestartPolicy;

  /**
   * Gives this container a platform-managed injected Chalk user identity if set.
   *
   * @generated from field: optional chalk.container.v1.ChalkWorkloadIdentity chalk_workload_identity = 21;
   */
  chalkWorkloadIdentity?: ChalkWorkloadIdentity;

  /**
   * Managed SSH aliases backed by Chalk Secrets. Each destination's resolved
   * IP address and port are authorized independently of network_policy.
   *
   * @generated from field: map<string, chalk.container.v1.ManagedSshDestination> managed_ssh = 22;
   */
  managedSsh: { [key: string]: ManagedSshDestination };

  /**
   * Restores this snapshot instead of cold-starting. Requires HOST compute class.
   * Every scaling group replica restores it. Its recorded resources, volumes and network policy apply.
   *
   * @generated from field: optional string restore_from_snapshot_id = 23;
   */
  restoreFromSnapshotId?: string;

  /**
   * System-managed requirements copied from the saved snapshot on resume/fork.
   * Absence on a restore means unclassified legacy state, not unrestricted placement.
   *
   * @generated from field: chalk.container.v1.SnapshotCompatibilityRequirements snapshot_requirements = 25;
   */
  snapshotRequirements?: SnapshotCompatibilityRequirements;

  /**
   * @generated from oneof chalk.container.v1.ChalkContainerSpec.placement
   */
  placement: {
    /**
     * Placement constraints for host class containers.
     *
     * @generated from field: chalk.container.v1.HostPlacementOptions host_placement = 24;
     */
    value: HostPlacementOptions;
    case: "hostPlacement";
  } | { case: undefined; value?: undefined };

  /**
   * Placement for new resources. Scaling group updates retain their recorded cluster.
   *
   * @generated from field: chalk.container.v1.ExecutionTarget execution_target = 26;
   */
  executionTarget?: ExecutionTarget;

  /**
   * Detects resources the sandbox creates through its egress traffic, such as
   * GitHub pull requests, and records them against the sandbox. Unset or empty
   * disables detection. Has no effect for hosts network_policy doesn't allow.
   *
   * @generated from field: chalk.container.v1.ResourceDetectionConfig resource_detection = 27;
   */
  resourceDetection?: ResourceDetectionConfig;

  /**
   * Container runtime on HOST compute. Unspecified uses gVisor. An explicit
   * selection requires HOST compute and a host that supports that runtime.
   *
   * @generated from field: chalk.container.v1.Runtime runtime = 28;
   */
  runtime: Runtime;

  /**
   * Immutable aggregate limits shared by this sandbox and its descendants.
   * This may only be configured when creating a root sandbox principal.
   *
   * @generated from field: chalk.container.v1.SandboxGroupLimits group_limits = 29;
   */
  groupLimits?: SandboxGroupLimits;
};

/**
 * Describes the message chalk.container.v1.ChalkContainerSpec.
 * Use `create(ChalkContainerSpecSchema)` to create a new message.
 */
export const ChalkContainerSpecSchema: GenMessage<ChalkContainerSpec> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 4);

/**
 * @generated from message chalk.container.v1.ResourceDetectionConfig
 */
export type ResourceDetectionConfig = Message<"chalk.container.v1.ResourceDetectionConfig"> & {
  /**
   * Detectors to enable. Each inspects egress traffic to the hosts it
   * recognizes. UNSPECIFIED is rejected.
   *
   * @generated from field: repeated chalk.container.v1.ResourceDetector detectors = 1;
   */
  detectors: ResourceDetector[];
};

/**
 * Describes the message chalk.container.v1.ResourceDetectionConfig.
 * Use `create(ResourceDetectionConfigSchema)` to create a new message.
 */
export const ResourceDetectionConfigSchema: GenMessage<ResourceDetectionConfig> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 5);

/**
 * @generated from message chalk.container.v1.ExecutionTarget
 */
export type ExecutionTarget = Message<"chalk.container.v1.ExecutionTarget"> & {
  /**
   * On creation, ENVIRONMENT uses the environment's cluster; SERVERLESS selects serverless compute.
   *
   * @generated from field: chalk.container.v1.ExecutionBackend backend = 1;
   */
  backend: ExecutionBackend;
};

/**
 * Describes the message chalk.container.v1.ExecutionTarget.
 * Use `create(ExecutionTargetSchema)` to create a new message.
 */
export const ExecutionTargetSchema: GenMessage<ExecutionTarget> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 6);

/**
 * @generated from message chalk.container.v1.StartupProbe
 */
export type StartupProbe = Message<"chalk.container.v1.StartupProbe"> & {
  /**
   * @generated from oneof chalk.container.v1.StartupProbe.check
   */
  check: {
    /**
     * @generated from field: chalk.container.v1.HttpProbe http = 1;
     */
    value: HttpProbe;
    case: "http";
  } | {
    /**
     * @generated from field: chalk.container.v1.GrpcProbe grpc = 2;
     */
    value: GrpcProbe;
    case: "grpc";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.container.v1.StartupProbe.
 * Use `create(StartupProbeSchema)` to create a new message.
 */
export const StartupProbeSchema: GenMessage<StartupProbe> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 7);

/**
 * @generated from message chalk.container.v1.HttpProbe
 */
export type HttpProbe = Message<"chalk.container.v1.HttpProbe"> & {
  /**
   * HTTP path, for example /healthz. An empty value uses /.
   *
   * @generated from field: optional string path = 1;
   */
  path?: string;
};

/**
 * Describes the message chalk.container.v1.HttpProbe.
 * Use `create(HttpProbeSchema)` to create a new message.
 */
export const HttpProbeSchema: GenMessage<HttpProbe> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 8);

/**
 * @generated from message chalk.container.v1.GrpcProbe
 */
export type GrpcProbe = Message<"chalk.container.v1.GrpcProbe"> & {
  /**
   * Fully-qualified gRPC method, for example /grpc.health.v1.Health/Check. An
   * empty value uses /chalk.health.v1.Probe/Check. A configured method is
   * expected to return OK (0).
   *
   * @generated from field: optional string method = 1;
   */
  method?: string;
};

/**
 * Describes the message chalk.container.v1.GrpcProbe.
 * Use `create(GrpcProbeSchema)` to create a new message.
 */
export const GrpcProbeSchema: GenMessage<GrpcProbe> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 9);

/**
 * @generated from message chalk.container.v1.ReadinessProbe
 */
export type ReadinessProbe = Message<"chalk.container.v1.ReadinessProbe"> & {
  /**
   * @generated from oneof chalk.container.v1.ReadinessProbe.check
   */
  check: {
    /**
     * HTTP GET readiness check. An empty path uses /.
     *
     * @generated from field: chalk.container.v1.HttpProbe http = 1;
     */
    value: HttpProbe;
    case: "http";
  } | {
    /**
     * Standard grpc.health.v1.Health/Check readiness check.
     *
     * @generated from field: chalk.container.v1.GrpcHealthProbe grpc = 2;
     */
    value: GrpcHealthProbe;
    case: "grpc";
  } | { case: undefined; value?: undefined };

  /**
   * Time between checks in seconds.
   *
   * @generated from field: optional int32 period_seconds = 3;
   */
  periodSeconds?: number;

  /**
   * Time to wait for a response in seconds.
   *
   * @generated from field: optional int32 timeout_seconds = 4;
   */
  timeoutSeconds?: number;

  /**
   * Consecutive failures before the instance is removed from service.
   *
   * @generated from field: optional int32 failure_threshold = 5;
   */
  failureThreshold?: number;
};

/**
 * Describes the message chalk.container.v1.ReadinessProbe.
 * Use `create(ReadinessProbeSchema)` to create a new message.
 */
export const ReadinessProbeSchema: GenMessage<ReadinessProbe> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 10);

/**
 * @generated from message chalk.container.v1.GrpcHealthProbe
 */
export type GrpcHealthProbe = Message<"chalk.container.v1.GrpcHealthProbe"> & {
  /**
   * Service passed to grpc.health.v1.Health/Check. Empty checks the overall
   * server health.
   *
   * @generated from field: optional string service = 1;
   */
  service?: string;
};

/**
 * Describes the message chalk.container.v1.GrpcHealthProbe.
 * Use `create(GrpcHealthProbeSchema)` to create a new message.
 */
export const GrpcHealthProbeSchema: GenMessage<GrpcHealthProbe> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 11);

/**
 * @generated from message chalk.container.v1.ContainerSecurityPolicy
 */
export type ContainerSecurityPolicy = Message<"chalk.container.v1.ContainerSecurityPolicy"> & {
  /**
   * Kernel hardening policy, for syscalls, host access, etc. (defaults to RESTRICTED)
   * RESTRICTED enables a number of sandboxing security controls
   *
   * @generated from field: optional chalk.container.v1.KernelPolicy kernel_policy = 1;
   */
  kernelPolicy?: KernelPolicy;
};

/**
 * Describes the message chalk.container.v1.ContainerSecurityPolicy.
 * Use `create(ContainerSecurityPolicySchema)` to create a new message.
 */
export const ContainerSecurityPolicySchema: GenMessage<ContainerSecurityPolicy> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 12);

/**
 * @generated from message chalk.container.v1.NetworkPolicy
 */
export type NetworkPolicy = Message<"chalk.container.v1.NetworkPolicy"> & {
  /**
   * Allowlist of destination routes and allowed ports.
   *
   * @generated from field: repeated chalk.container.v1.AllowedRoute allowed_routes = 1;
   */
  allowedRoutes: AllowedRoute[];

  /**
   * Denylist of destination CIDRs. Takes precedence over allowed routes and
   * host policy rules.
   *
   * @generated from field: repeated string denied_routes = 2;
   */
  deniedRoutes: string[];

  /**
   * Hostname-level outbound policy. Empty policy means deny-all for HOST
   * containers.
   *
   * @generated from field: map<string, chalk.container.v1.NetworkPolicyRuleList> allowed_hosts = 3;
   */
  allowedHosts: { [key: string]: NetworkPolicyRuleList };
};

/**
 * Describes the message chalk.container.v1.NetworkPolicy.
 * Use `create(NetworkPolicySchema)` to create a new message.
 */
export const NetworkPolicySchema: GenMessage<NetworkPolicy> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 13);

/**
 * @generated from message chalk.container.v1.AllowedRoute
 */
export type AllowedRoute = Message<"chalk.container.v1.AllowedRoute"> & {
  /**
   * Destination CIDR, e.g. "10.0.0.0/8".
   *
   * @generated from field: string route = 1;
   */
  route: string;

  /**
   * Destination ports allowed for this route. Empty means all ports.
   *
   * @generated from field: repeated chalk.container.v1.PortRange port_ranges = 2;
   */
  portRanges: PortRange[];
};

/**
 * Describes the message chalk.container.v1.AllowedRoute.
 * Use `create(AllowedRouteSchema)` to create a new message.
 */
export const AllowedRouteSchema: GenMessage<AllowedRoute> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 14);

/**
 * @generated from message chalk.container.v1.PortRange
 */
export type PortRange = Message<"chalk.container.v1.PortRange"> & {
  /**
   * Inclusive start port. Must be between 1 and 65535.
   *
   * @generated from field: int32 start_port = 1;
   */
  startPort: number;

  /**
   * Inclusive end port. Must be greater than or equal to start_port.
   *
   * @generated from field: int32 end_port = 2;
   */
  endPort: number;
};

/**
 * Describes the message chalk.container.v1.PortRange.
 * Use `create(PortRangeSchema)` to create a new message.
 */
export const PortRangeSchema: GenMessage<PortRange> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 15);

/**
 * @generated from message chalk.container.v1.NetworkPolicyRuleList
 */
export type NetworkPolicyRuleList = Message<"chalk.container.v1.NetworkPolicyRuleList"> & {
  /**
   * @generated from field: repeated chalk.container.v1.NetworkPolicyRule rules = 1;
   */
  rules: NetworkPolicyRule[];
};

/**
 * Describes the message chalk.container.v1.NetworkPolicyRuleList.
 * Use `create(NetworkPolicyRuleListSchema)` to create a new message.
 */
export const NetworkPolicyRuleListSchema: GenMessage<NetworkPolicyRuleList> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 16);

/**
 * @generated from message chalk.container.v1.NetworkPolicyRule
 */
export type NetworkPolicyRule = Message<"chalk.container.v1.NetworkPolicyRule"> & {
  /**
   * Optional header(s) to set on the outgoing request.
   *
   * @generated from field: repeated chalk.container.v1.NetworkTransformer transform = 1;
   */
  transform: NetworkTransformer[];

  /**
   * Optional request matcher. When set, transforms and forwarding only apply
   * to requests matching every specified dimension.
   *
   * @generated from field: optional chalk.container.v1.NetworkPolicyMatch match = 2;
   */
  match?: NetworkPolicyMatch;

  /**
   * HTTP/HTTPS URL to forward matching requests to.
   * Must not include a query string or fragment.
   *
   * @generated from field: optional string forward_url = 3;
   */
  forwardUrl?: string;
};

/**
 * Describes the message chalk.container.v1.NetworkPolicyRule.
 * Use `create(NetworkPolicyRuleSchema)` to create a new message.
 */
export const NetworkPolicyRuleSchema: GenMessage<NetworkPolicyRule> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 17);

/**
 * @generated from message chalk.container.v1.NetworkTransformer
 */
export type NetworkTransformer = Message<"chalk.container.v1.NetworkTransformer"> & {
  /**
   * @generated from field: map<string, string> headers = 1;
   */
  headers: { [key: string]: string };

  /**
   * Maps placeholder tokens in request header values to Chalk Secret names.
   * Every occurrence of a placeholder in an ordinary outbound header value is
   * replaced with the named Secret's contents after this transform's literal
   * headers are applied. Authority, framing, hop-by-hop, and Chalk-owned routing
   * headers are excluded.
   *
   * @generated from field: map<string, string> headers_secrets = 2;
   */
  headersSecrets: { [key: string]: string };
};

/**
 * Describes the message chalk.container.v1.NetworkTransformer.
 * Use `create(NetworkTransformerSchema)` to create a new message.
 */
export const NetworkTransformerSchema: GenMessage<NetworkTransformer> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 18);

/**
 * @generated from message chalk.container.v1.NetworkPolicyMatch
 */
export type NetworkPolicyMatch = Message<"chalk.container.v1.NetworkPolicyMatch"> & {
  /**
   * Match on the request path.
   *
   * @generated from field: optional chalk.container.v1.NetworkPolicyMatcher path = 1;
   */
  path?: NetworkPolicyMatcher;

  /**
   * HTTP methods to match. Multiple values are ORed.
   *
   * @generated from field: repeated string method = 2;
   */
  method: string[];

  /**
   * Query-string entry matchers. Multiple matchers are ANDed.
   *
   * @generated from field: repeated chalk.container.v1.NetworkPolicyKeyValueMatcher query_string = 3;
   */
  queryString: NetworkPolicyKeyValueMatcher[];

  /**
   * Request header matchers. Multiple matchers are ANDed.
   *
   * @generated from field: repeated chalk.container.v1.NetworkPolicyKeyValueMatcher headers = 4;
   */
  headers: NetworkPolicyKeyValueMatcher[];
};

/**
 * Describes the message chalk.container.v1.NetworkPolicyMatch.
 * Use `create(NetworkPolicyMatchSchema)` to create a new message.
 */
export const NetworkPolicyMatchSchema: GenMessage<NetworkPolicyMatch> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 19);

/**
 * @generated from message chalk.container.v1.NetworkPolicyKeyValueMatcher
 */
export type NetworkPolicyKeyValueMatcher = Message<"chalk.container.v1.NetworkPolicyKeyValueMatcher"> & {
  /**
   * Matcher for the entry key.
   *
   * @generated from field: optional chalk.container.v1.NetworkPolicyMatcher key = 1;
   */
  key?: NetworkPolicyMatcher;

  /**
   * Matcher for the entry value. Missing value means present-match.
   *
   * @generated from field: optional chalk.container.v1.NetworkPolicyMatcher value = 2;
   */
  value?: NetworkPolicyMatcher;
};

/**
 * Describes the message chalk.container.v1.NetworkPolicyKeyValueMatcher.
 * Use `create(NetworkPolicyKeyValueMatcherSchema)` to create a new message.
 */
export const NetworkPolicyKeyValueMatcherSchema: GenMessage<NetworkPolicyKeyValueMatcher> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 20);

/**
 * @generated from message chalk.container.v1.NetworkPolicyMatcher
 */
export type NetworkPolicyMatcher = Message<"chalk.container.v1.NetworkPolicyMatcher"> & {
  /**
   * @generated from oneof chalk.container.v1.NetworkPolicyMatcher.matcher
   */
  matcher: {
    /**
     * Match the value exactly.
     *
     * @generated from field: string exact = 1;
     */
    value: string;
    case: "exact";
  } | {
    /**
     * Match values that start with the provided prefix.
     *
     * @generated from field: string starts_with = 2;
     */
    value: string;
    case: "startsWith";
  } | {
    /**
     * Match values against a regular expression.
     *
     * @generated from field: string regex = 3;
     */
    value: string;
    case: "regex";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.container.v1.NetworkPolicyMatcher.
 * Use `create(NetworkPolicyMatcherSchema)` to create a new message.
 */
export const NetworkPolicyMatcherSchema: GenMessage<NetworkPolicyMatcher> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 21);

/**
 * @generated from message chalk.container.v1.ContainerRequest
 */
export type ContainerRequest = Message<"chalk.container.v1.ContainerRequest"> & {
  /**
   * Container specification - immutable properties defining what to run
   *
   * @generated from field: chalk.container.v1.ChalkContainerSpec spec = 1;
   */
  spec?: ChalkContainerSpec;
};

/**
 * Describes the message chalk.container.v1.ContainerRequest.
 * Use `create(ContainerRequestSchema)` to create a new message.
 */
export const ContainerRequestSchema: GenMessage<ContainerRequest> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 22);

/**
 * Result of an HTTP healthcheck against a container's exposed port
 *
 * @generated from message chalk.container.v1.HealthCheck
 */
export type HealthCheck = Message<"chalk.container.v1.HealthCheck"> & {
  /**
   * Whether the container responded with HTTP 200
   *
   * @generated from field: bool healthy = 1;
   */
  healthy: boolean;

  /**
   * HTTP status code returned, if any
   *
   * @generated from field: optional int32 status_code = 2;
   */
  statusCode?: number;

  /**
   * Error message if the healthcheck failed (connection refused, timeout, etc.)
   *
   * @generated from field: optional string error = 3;
   */
  error?: string;
};

/**
 * Describes the message chalk.container.v1.HealthCheck.
 * Use `create(HealthCheckSchema)` to create a new message.
 */
export const HealthCheckSchema: GenMessage<HealthCheck> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 23);

/**
 * @generated from message chalk.container.v1.ContainerResponse
 */
export type ContainerResponse = Message<"chalk.container.v1.ContainerResponse"> & {
  /**
   * Container UUID (generated)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * User-provided name
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Container status: Pending, Running, Succeeded, Failed, Unknown
   *
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * Optional status message with more details
   *
   * @generated from field: optional string status_message = 4;
   */
  statusMessage?: string;

  /**
   * The immutable specification that was provided at creation time
   *
   * @generated from field: chalk.container.v1.ChalkContainerSpec spec = 5;
   */
  spec?: ChalkContainerSpec;

  /**
   * When the container was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * When the container was stopped (if stopped)
   *
   * @generated from field: optional google.protobuf.Timestamp stopped_at = 7;
   */
  stoppedAt?: Timestamp;

  /**
   * Kubernetes pod name (computed)
   *
   * @generated from field: string pod_name = 8;
   */
  podName: string;

  /**
   * Web URL to access the container (computed, if available)
   *
   * @generated from field: optional string web_url = 9;
   */
  webUrl?: string;

  /**
   * Deprecated: inbound SSH access to running containers is no longer supported.
   *
   * @generated from field: optional string ssh_private_key = 10 [deprecated = true];
   * @deprecated
   */
  sshPrivateKey?: string;

  /**
   * Deprecated: inbound SSH access to running containers is no longer supported.
   *
   * @generated from field: optional string ssh_username = 11 [deprecated = true];
   * @deprecated
   */
  sshUsername?: string;

  /**
   * Deprecated: inbound SSH access to running containers is no longer supported.
   *
   * @generated from field: optional string ssh_host = 12 [deprecated = true];
   * @deprecated
   */
  sshHost?: string;

  /**
   * Deprecated: inbound SSH access to running containers is no longer supported.
   *
   * @generated from field: optional int32 ssh_port = 13 [deprecated = true];
   * @deprecated
   */
  sshPort?: number;

  /**
   * Result of an HTTP healthcheck against the container's web_url
   * Only populated for containers with an exposed port and web_url
   *
   * @generated from field: optional chalk.container.v1.HealthCheck health_check = 14;
   */
  healthCheck?: HealthCheck;

  /**
   * Cloud region of the stored container cluster. Empty when unknown.
   *
   * @generated from field: string region = 15;
   */
  region: string;

  /**
   * User or service-token ID, absent when the creator is unknown.
   *
   * @generated from field: optional string created_by = 16;
   */
  createdBy?: string;

  /**
   * Additional diagnostic info for status.
   *
   * @generated from field: optional string status_details = 17;
   */
  statusDetails?: string;

  /**
   * Cluster where this container is placed.
   *
   * @generated from field: string cluster_id = 18;
   */
  clusterId: string;

  /**
   * Machine-readable status reason, independent of diagnostic text.
   *
   * @generated from field: chalk.container.v1.ContainerStatusReason status_reason = 19;
   */
  statusReason: ContainerStatusReason;
};

/**
 * Describes the message chalk.container.v1.ContainerResponse.
 * Use `create(ContainerResponseSchema)` to create a new message.
 */
export const ContainerResponseSchema: GenMessage<ContainerResponse> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 24);

/**
 * @generated from message chalk.container.v1.RunContainerRequest
 */
export type RunContainerRequest = Message<"chalk.container.v1.RunContainerRequest"> & {
  /**
   * @generated from field: chalk.container.v1.ContainerRequest container = 1;
   */
  container?: ContainerRequest;
};

/**
 * Describes the message chalk.container.v1.RunContainerRequest.
 * Use `create(RunContainerRequestSchema)` to create a new message.
 */
export const RunContainerRequestSchema: GenMessage<RunContainerRequest> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 25);

/**
 * @generated from message chalk.container.v1.RunContainerResponse
 */
export type RunContainerResponse = Message<"chalk.container.v1.RunContainerResponse"> & {
  /**
   * @generated from field: chalk.container.v1.ContainerResponse container = 1;
   */
  container?: ContainerResponse;
};

/**
 * Describes the message chalk.container.v1.RunContainerResponse.
 * Use `create(RunContainerResponseSchema)` to create a new message.
 */
export const RunContainerResponseSchema: GenMessage<RunContainerResponse> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 26);

/**
 * @generated from message chalk.container.v1.StopContainerRequest
 */
export type StopContainerRequest = Message<"chalk.container.v1.StopContainerRequest"> & {
  /**
   * The container ID to stop (either id or name must be provided)
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * The container name to stop (either id or name must be provided)
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * Optional grace period in seconds for container termination
   *
   * @generated from field: optional int32 grace_period_seconds = 3;
   */
  gracePeriodSeconds?: number;
};

/**
 * Describes the message chalk.container.v1.StopContainerRequest.
 * Use `create(StopContainerRequestSchema)` to create a new message.
 */
export const StopContainerRequestSchema: GenMessage<StopContainerRequest> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 27);

/**
 * @generated from message chalk.container.v1.StopContainerResponse
 */
export type StopContainerResponse = Message<"chalk.container.v1.StopContainerResponse"> & {
  /**
   * @generated from field: chalk.container.v1.ContainerResponse container = 1;
   */
  container?: ContainerResponse;
};

/**
 * Describes the message chalk.container.v1.StopContainerResponse.
 * Use `create(StopContainerResponseSchema)` to create a new message.
 */
export const StopContainerResponseSchema: GenMessage<StopContainerResponse> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 28);

/**
 * @generated from message chalk.container.v1.GetContainerRequest
 */
export type GetContainerRequest = Message<"chalk.container.v1.GetContainerRequest"> & {
  /**
   * The container ID to get (either id or name must be provided)
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * The container name to get (either id or name must be provided)
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional bool include_stopped = 3;
   */
  includeStopped?: boolean;
};

/**
 * Describes the message chalk.container.v1.GetContainerRequest.
 * Use `create(GetContainerRequestSchema)` to create a new message.
 */
export const GetContainerRequestSchema: GenMessage<GetContainerRequest> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 29);

/**
 * @generated from message chalk.container.v1.GetContainerResponse
 */
export type GetContainerResponse = Message<"chalk.container.v1.GetContainerResponse"> & {
  /**
   * @generated from field: chalk.container.v1.ContainerResponse container = 1;
   */
  container?: ContainerResponse;
};

/**
 * Describes the message chalk.container.v1.GetContainerResponse.
 * Use `create(GetContainerResponseSchema)` to create a new message.
 */
export const GetContainerResponseSchema: GenMessage<GetContainerResponse> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 30);

/**
 * @generated from message chalk.container.v1.ListContainersRequest
 */
export type ListContainersRequest = Message<"chalk.container.v1.ListContainersRequest"> & {
  /**
   * @generated from field: optional string cursor = 1;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * Deprecated in favor of `statuses`: a non-empty `statuses` filter fully
   * governs stopped inclusion. Retained for old clients; honored only when
   * `statuses` is empty.
   *
   * @generated from field: optional bool include_stopped = 3;
   */
  includeStopped?: boolean;

  /**
   * Server-side filters (empty = no filter). `statuses` matches the stored
   * execution status, including stopped containers (Pending/Running/Succeeded/
   * Failed/Unknown/Error). `images` matches the container spec image exactly.
   * `search` is a case-insensitive substring match on name or id.
   *
   * @generated from field: repeated string statuses = 4;
   */
  statuses: string[];

  /**
   * @generated from field: repeated string images = 5;
   */
  images: string[];

  /**
   * @generated from field: optional string search = 6;
   */
  search?: string;

  /**
   * Ascending sweeps oldest-first by created_at; default (unset/false) is
   * newest-first. Direction is the created_at keyset direction.
   *
   * @generated from field: optional bool sort_ascending = 7;
   */
  sortAscending?: boolean;
};

/**
 * Describes the message chalk.container.v1.ListContainersRequest.
 * Use `create(ListContainersRequestSchema)` to create a new message.
 */
export const ListContainersRequestSchema: GenMessage<ListContainersRequest> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 31);

/**
 * @generated from message chalk.container.v1.ListContainersResponse
 */
export type ListContainersResponse = Message<"chalk.container.v1.ListContainersResponse"> & {
  /**
   * @generated from field: repeated chalk.container.v1.ContainerResponse containers = 1;
   */
  containers: ContainerResponse[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.container.v1.ListContainersResponse.
 * Use `create(ListContainersResponseSchema)` to create a new message.
 */
export const ListContainersResponseSchema: GenMessage<ListContainersResponse> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 32);

/**
 * @generated from message chalk.container.v1.ExecCommandRequest
 */
export type ExecCommandRequest = Message<"chalk.container.v1.ExecCommandRequest"> & {
  /**
   * The container ID to execute the command in (either id or name must be provided)
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * The container name to execute the command in (either id or name must be provided)
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * The command to execute (e.g., ["sh", "-c", "echo hello"])
   *
   * @generated from field: repeated string command = 3;
   */
  command: string[];

  /**
   * Optional timeout for the command execution
   *
   * @generated from field: optional google.protobuf.Duration timeout = 4;
   */
  timeout?: Duration;

  /**
   * Optional stdin data to pass to the command
   *
   * @generated from field: optional bytes stdin = 5;
   */
  stdin?: Uint8Array;
};

/**
 * Describes the message chalk.container.v1.ExecCommandRequest.
 * Use `create(ExecCommandRequestSchema)` to create a new message.
 */
export const ExecCommandRequestSchema: GenMessage<ExecCommandRequest> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 33);

/**
 * @generated from message chalk.container.v1.ExecCommandResponse
 */
export type ExecCommandResponse = Message<"chalk.container.v1.ExecCommandResponse"> & {
  /**
   * The stdout output from the command
   *
   * @generated from field: bytes stdout = 1;
   */
  stdout: Uint8Array;

  /**
   * The stderr output from the command
   *
   * @generated from field: bytes stderr = 2;
   */
  stderr: Uint8Array;

  /**
   * The exit code of the command
   *
   * @generated from field: int32 exit_code = 3;
   */
  exitCode: number;
};

/**
 * Describes the message chalk.container.v1.ExecCommandResponse.
 * Use `create(ExecCommandResponseSchema)` to create a new message.
 */
export const ExecCommandResponseSchema: GenMessage<ExecCommandResponse> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 34);

/**
 * @generated from message chalk.container.v1.SessionRequest
 */
export type SessionRequest = Message<"chalk.container.v1.SessionRequest"> & {
  /**
   * The first message on a stream must be either NewProcess or AttachSession
   *
   * @generated from oneof chalk.container.v1.SessionRequest.command
   */
  command: {
    /**
     * Start a new process and create a session
     *
     * @generated from field: chalk.container.v1.NewProcess new_process = 1;
     */
    value: NewProcess;
    case: "newProcess";
  } | {
    /**
     * Attach to an existing session
     *
     * @generated from field: chalk.container.v1.AttachSession attach_session = 2;
     */
    value: AttachSession;
    case: "attachSession";
  } | {
    /**
     * Detach from the current session
     *
     * @generated from field: chalk.container.v1.DetachSession detach_session = 3;
     */
    value: DetachSession;
    case: "detachSession";
  } | {
    /**
     * Send stdin data (or PTY input) to the process
     *
     * @generated from field: chalk.container.v1.StdinData stdin_data = 4;
     */
    value: StdinData;
    case: "stdinData";
  } | {
    /**
     * Signal that stdin is closed
     *
     * @generated from field: chalk.container.v1.StdinEof stdin_eof = 5;
     */
    value: StdinEof;
    case: "stdinEof";
  } | {
    /**
     * Send a signal to the process
     *
     * @generated from field: chalk.container.v1.SessionSignal signal = 6;
     */
    value: SessionSignal;
    case: "signal";
  } | {
    /**
     * Update PTY info from client
     *
     * @generated from field: chalk.container.v1.PtyInfo pty_info = 7;
     */
    value: PtyInfo;
    case: "ptyInfo";
  } | {
    /**
     * Request current process state
     *
     * @generated from field: chalk.container.v1.GetProcessStatus get_process_status = 8;
     */
    value: GetProcessStatus;
    case: "getProcessStatus";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.container.v1.SessionRequest.
 * Use `create(SessionRequestSchema)` to create a new message.
 */
export const SessionRequestSchema: GenMessage<SessionRequest> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 35);

/**
 * @generated from message chalk.container.v1.SessionResponse
 */
export type SessionResponse = Message<"chalk.container.v1.SessionResponse"> & {
  /**
   * @generated from oneof chalk.container.v1.SessionResponse.event
   */
  event: {
    /**
     * An error occurred
     *
     * @generated from field: chalk.container.v1.SessionError error = 1;
     */
    value: SessionError;
    case: "error";
  } | {
    /**
     * Successfully attached to a new or existing session
     *
     * @generated from field: chalk.container.v1.SessionAttached session_attached = 2;
     */
    value: SessionAttached;
    case: "sessionAttached";
  } | {
    /**
     * Output data from the process
     *
     * @generated from field: chalk.container.v1.OutputData output_data = 3;
     */
    value: OutputData;
    case: "outputData";
  } | {
    /**
     * Current process state
     *
     * @generated from field: chalk.container.v1.ProcessStatus process_status = 4;
     */
    value: ProcessStatus;
    case: "processStatus";
  } | {
    /**
     * Process has exited
     *
     * @generated from field: chalk.container.v1.ProcessExited process_exited = 6;
     */
    value: ProcessExited;
    case: "processExited";
  } | {
    /**
     * Session was detached
     *
     * @generated from field: chalk.container.v1.SessionDetached session_detached = 7;
     */
    value: SessionDetached;
    case: "sessionDetached";
  } | {
    /**
     * Process failed before it could exit normally
     *
     * @generated from field: chalk.container.v1.ProcessFailed process_failed = 8;
     */
    value: ProcessFailed;
    case: "processFailed";
  } | {
    /**
     * Process exceeded its configured timeout
     *
     * @generated from field: chalk.container.v1.ProcessTimedOut process_timed_out = 9;
     */
    value: ProcessTimedOut;
    case: "processTimedOut";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.container.v1.SessionResponse.
 * Use `create(SessionResponseSchema)` to create a new message.
 */
export const SessionResponseSchema: GenMessage<SessionResponse> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 36);

/**
 * Any session protocol errors
 *
 * @generated from message chalk.container.v1.SessionError
 */
export type SessionError = Message<"chalk.container.v1.SessionError"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message chalk.container.v1.SessionError.
 * Use `create(SessionErrorSchema)` to create a new message.
 */
export const SessionErrorSchema: GenMessage<SessionError> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 37);

/**
 * @generated from message chalk.container.v1.NewProcess
 */
export type NewProcess = Message<"chalk.container.v1.NewProcess"> & {
  /**
   * The container ID to execute the command in
   *
   * @generated from field: string container_id = 1;
   */
  containerId: string;

  /**
   * The command to execute
   *
   * @generated from field: string command = 2;
   */
  command: string;

  /**
   * Arguments to the command
   *
   * @generated from field: repeated string args = 3;
   */
  args: string[];

  /**
   * Optional working directory
   *
   * @generated from field: optional string workdir = 4;
   */
  workdir?: string;

  /**
   * Optional environment variables
   *
   * @generated from field: map<string, string> env = 5;
   */
  env: { [key: string]: string };

  /**
   * Optional timeout in seconds. Affects both normal and PTY sessions!
   *
   * @generated from field: optional uint64 timeout_secs = 6;
   */
  timeoutSecs?: bigint;

  /**
   * Optional PTY configuration. When set, the process runs in a PTY
   * and all output is merged into a single PTY output stream.
   *
   * @generated from field: optional chalk.container.v1.PtyInfo pty_info = 7;
   */
  ptyInfo?: PtyInfo;
};

/**
 * Describes the message chalk.container.v1.NewProcess.
 * Use `create(NewProcessSchema)` to create a new message.
 */
export const NewProcessSchema: GenMessage<NewProcess> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 38);

/**
 * @generated from message chalk.container.v1.PtyInfo
 */
export type PtyInfo = Message<"chalk.container.v1.PtyInfo"> & {
  /**
   * Terminal columns
   *
   * @generated from field: uint32 cols = 1;
   */
  cols: number;

  /**
   * Terminal rows
   *
   * @generated from field: uint32 rows = 2;
   */
  rows: number;
};

/**
 * Describes the message chalk.container.v1.PtyInfo.
 * Use `create(PtyInfoSchema)` to create a new message.
 */
export const PtyInfoSchema: GenMessage<PtyInfo> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 39);

/**
 * @generated from message chalk.container.v1.AttachSession
 */
export type AttachSession = Message<"chalk.container.v1.AttachSession"> & {
  /**
   * @generated from field: string container_id = 1;
   */
  containerId: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * PTY dimensions for the attached session. Must be set when attaching to a PTY session.
   *
   * @generated from field: optional chalk.container.v1.PtyInfo pty_info = 3;
   */
  ptyInfo?: PtyInfo;
};

/**
 * Describes the message chalk.container.v1.AttachSession.
 * Use `create(AttachSessionSchema)` to create a new message.
 */
export const AttachSessionSchema: GenMessage<AttachSession> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 40);

/**
 * @generated from message chalk.container.v1.SessionAttached
 */
export type SessionAttached = Message<"chalk.container.v1.SessionAttached"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message chalk.container.v1.SessionAttached.
 * Use `create(SessionAttachedSchema)` to create a new message.
 */
export const SessionAttachedSchema: GenMessage<SessionAttached> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 41);

/**
 * @generated from message chalk.container.v1.DetachSession
 */
export type DetachSession = Message<"chalk.container.v1.DetachSession"> & {
};

/**
 * Describes the message chalk.container.v1.DetachSession.
 * Use `create(DetachSessionSchema)` to create a new message.
 */
export const DetachSessionSchema: GenMessage<DetachSession> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 42);

/**
 * @generated from message chalk.container.v1.SessionDetached
 */
export type SessionDetached = Message<"chalk.container.v1.SessionDetached"> & {
};

/**
 * Describes the message chalk.container.v1.SessionDetached.
 * Use `create(SessionDetachedSchema)` to create a new message.
 */
export const SessionDetachedSchema: GenMessage<SessionDetached> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 43);

/**
 * @generated from message chalk.container.v1.StdinData
 */
export type StdinData = Message<"chalk.container.v1.StdinData"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;
};

/**
 * Describes the message chalk.container.v1.StdinData.
 * Use `create(StdinDataSchema)` to create a new message.
 */
export const StdinDataSchema: GenMessage<StdinData> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 44);

/**
 * @generated from message chalk.container.v1.StdinEof
 */
export type StdinEof = Message<"chalk.container.v1.StdinEof"> & {
};

/**
 * Describes the message chalk.container.v1.StdinEof.
 * Use `create(StdinEofSchema)` to create a new message.
 */
export const StdinEofSchema: GenMessage<StdinEof> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 45);

/**
 * @generated from message chalk.container.v1.SessionSignal
 */
export type SessionSignal = Message<"chalk.container.v1.SessionSignal"> & {
  /**
   * @generated from field: int32 signal = 1;
   */
  signal: number;
};

/**
 * Describes the message chalk.container.v1.SessionSignal.
 * Use `create(SessionSignalSchema)` to create a new message.
 */
export const SessionSignalSchema: GenMessage<SessionSignal> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 46);

/**
 * @generated from message chalk.container.v1.OutputData
 */
export type OutputData = Message<"chalk.container.v1.OutputData"> & {
  /**
   * @generated from field: chalk.container.v1.OutputData.Stream stream = 1;
   */
  stream: OutputData_Stream;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;
};

/**
 * Describes the message chalk.container.v1.OutputData.
 * Use `create(OutputDataSchema)` to create a new message.
 */
export const OutputDataSchema: GenMessage<OutputData> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 47);

/**
 * @generated from enum chalk.container.v1.OutputData.Stream
 */
export enum OutputData_Stream {
  /**
   * @generated from enum value: STREAM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STREAM_STDOUT = 1;
   */
  STDOUT = 1,

  /**
   * @generated from enum value: STREAM_STDERR = 2;
   */
  STDERR = 2,

  /**
   * PTY output (merged stdout/stderr from a PTY session)
   *
   * @generated from enum value: STREAM_PTY_OUTPUT = 3;
   */
  PTY_OUTPUT = 3,
}

/**
 * Describes the enum chalk.container.v1.OutputData.Stream.
 */
export const OutputData_StreamSchema: GenEnum<OutputData_Stream> = /*@__PURE__*/
  enumDesc(file_chalk_container_v1_service, 47, 0);

/**
 * @generated from message chalk.container.v1.GetProcessStatus
 */
export type GetProcessStatus = Message<"chalk.container.v1.GetProcessStatus"> & {
};

/**
 * Describes the message chalk.container.v1.GetProcessStatus.
 * Use `create(GetProcessStatusSchema)` to create a new message.
 */
export const GetProcessStatusSchema: GenMessage<GetProcessStatus> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 48);

/**
 * @generated from message chalk.container.v1.ProcessStatus
 */
export type ProcessStatus = Message<"chalk.container.v1.ProcessStatus"> & {
  /**
   * @generated from field: chalk.container.v1.ProcessState state = 1;
   */
  state: ProcessState;

  /**
   * Exit code when state is EXITED or TIMED_OUT.
   *
   * @generated from field: optional int32 exit_code = 2;
   */
  exitCode?: number;

  /**
   * Signal when state is EXITED or TIMED_OUT.
   *
   * @generated from field: optional int32 signal = 3;
   */
  signal?: number;
};

/**
 * Describes the message chalk.container.v1.ProcessStatus.
 * Use `create(ProcessStatusSchema)` to create a new message.
 */
export const ProcessStatusSchema: GenMessage<ProcessStatus> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 49);

/**
 * @generated from message chalk.container.v1.ProcessExited
 */
export type ProcessExited = Message<"chalk.container.v1.ProcessExited"> & {
  /**
   * @generated from field: optional int32 exit_code = 1;
   */
  exitCode?: number;

  /**
   * @generated from field: optional int32 signal = 2;
   */
  signal?: number;
};

/**
 * Describes the message chalk.container.v1.ProcessExited.
 * Use `create(ProcessExitedSchema)` to create a new message.
 */
export const ProcessExitedSchema: GenMessage<ProcessExited> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 50);

/**
 * @generated from message chalk.container.v1.ProcessFailed
 */
export type ProcessFailed = Message<"chalk.container.v1.ProcessFailed"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message chalk.container.v1.ProcessFailed.
 * Use `create(ProcessFailedSchema)` to create a new message.
 */
export const ProcessFailedSchema: GenMessage<ProcessFailed> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 51);

/**
 * @generated from message chalk.container.v1.ProcessTimedOut
 */
export type ProcessTimedOut = Message<"chalk.container.v1.ProcessTimedOut"> & {
  /**
   * @generated from field: optional int32 exit_code = 1;
   */
  exitCode?: number;

  /**
   * @generated from field: optional int32 signal = 2;
   */
  signal?: number;
};

/**
 * Describes the message chalk.container.v1.ProcessTimedOut.
 * Use `create(ProcessTimedOutSchema)` to create a new message.
 */
export const ProcessTimedOutSchema: GenMessage<ProcessTimedOut> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 52);

/**
 * @generated from message chalk.container.v1.SessionInfo
 */
export type SessionInfo = Message<"chalk.container.v1.SessionInfo"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: chalk.container.v1.NewProcess new_process = 2;
   */
  newProcess?: NewProcess;

  /**
   * @generated from field: chalk.container.v1.ProcessStatus process_status = 3;
   */
  processStatus?: ProcessStatus;
};

/**
 * Describes the message chalk.container.v1.SessionInfo.
 * Use `create(SessionInfoSchema)` to create a new message.
 */
export const SessionInfoSchema: GenMessage<SessionInfo> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 53);

/**
 * @generated from message chalk.container.v1.GetSessionRequest
 */
export type GetSessionRequest = Message<"chalk.container.v1.GetSessionRequest"> & {
  /**
   * @generated from field: string container_id = 1;
   */
  containerId: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;
};

/**
 * Describes the message chalk.container.v1.GetSessionRequest.
 * Use `create(GetSessionRequestSchema)` to create a new message.
 */
export const GetSessionRequestSchema: GenMessage<GetSessionRequest> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 54);

/**
 * @generated from message chalk.container.v1.GetSessionResponse
 */
export type GetSessionResponse = Message<"chalk.container.v1.GetSessionResponse"> & {
  /**
   * @generated from field: chalk.container.v1.SessionInfo session = 1;
   */
  session?: SessionInfo;
};

/**
 * Describes the message chalk.container.v1.GetSessionResponse.
 * Use `create(GetSessionResponseSchema)` to create a new message.
 */
export const GetSessionResponseSchema: GenMessage<GetSessionResponse> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 55);

/**
 * @generated from message chalk.container.v1.ListSessionsRequest
 */
export type ListSessionsRequest = Message<"chalk.container.v1.ListSessionsRequest"> & {
  /**
   * @generated from field: string container_id = 1;
   */
  containerId: string;
};

/**
 * Describes the message chalk.container.v1.ListSessionsRequest.
 * Use `create(ListSessionsRequestSchema)` to create a new message.
 */
export const ListSessionsRequestSchema: GenMessage<ListSessionsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 56);

/**
 * @generated from message chalk.container.v1.ListSessionsResponse
 */
export type ListSessionsResponse = Message<"chalk.container.v1.ListSessionsResponse"> & {
  /**
   * @generated from field: repeated chalk.container.v1.SessionInfo sessions = 1;
   */
  sessions: SessionInfo[];
};

/**
 * Describes the message chalk.container.v1.ListSessionsResponse.
 * Use `create(ListSessionsResponseSchema)` to create a new message.
 */
export const ListSessionsResponseSchema: GenMessage<ListSessionsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 57);

/**
 * @generated from message chalk.container.v1.ContainerHostInfo
 */
export type ContainerHostInfo = Message<"chalk.container.v1.ContainerHostInfo"> & {
  /**
   * Host id, which is unique per host. Note that by combining this with the DNS zone for
   * the cluster this host runs on, a FQDN for reaching the host can be constructed.
   *
   * @generated from field: string host_id = 1;
   */
  hostId: string;

  /**
   * Actual selected pool. Omitted by older controllers.
   *
   * @generated from field: optional string host_pool_id = 2;
   */
  hostPoolId?: string;
};

/**
 * Describes the message chalk.container.v1.ContainerHostInfo.
 * Use `create(ContainerHostInfoSchema)` to create a new message.
 */
export const ContainerHostInfoSchema: GenMessage<ContainerHostInfo> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 58);

/**
 * @generated from message chalk.container.v1.UpdateContainerStatusRequest
 */
export type UpdateContainerStatusRequest = Message<"chalk.container.v1.UpdateContainerStatusRequest"> & {
  /**
   * Container UUID (from pod label chalk.ai/container)
   *
   * @generated from field: string container_id = 1;
   */
  containerId: string;

  /**
   * Pod phase: Pending, Running, Succeeded, Failed, Unknown, Error.
   *
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * Optional status message with more details
   *
   * @generated from field: optional string status_message = 3;
   */
  statusMessage?: string;

  /**
   * Host information, only populated for host compute class containers.
   *
   * @generated from field: optional chalk.container.v1.ContainerHostInfo host_info = 4;
   */
  hostInfo?: ContainerHostInfo;

  /**
   * Time at which the dataplane controller observed this status.
   * When present, used to reject stale timestamped observations. Legacy clients may omit it.
   *
   * @generated from field: optional google.protobuf.Timestamp observed_at = 5;
   */
  observedAt?: Timestamp;

  /**
   * Additional diagnostic info for status.
   *
   * @generated from field: optional string status_details = 6;
   */
  statusDetails?: string;

  /**
   * First known backend execution start, preserved across resume.
   *
   * @generated from field: optional google.protobuf.Timestamp execution_started_at = 7;
   */
  executionStartedAt?: Timestamp;

  /**
   * Backend execution stop, distinct from operational stopped_at; cleared on resume.
   *
   * @generated from field: optional google.protobuf.Timestamp execution_stopped_at = 8;
   */
  executionStoppedAt?: Timestamp;

  /**
   * Absent preserves the stored reason; UNSPECIFIED explicitly clears it.
   *
   * @generated from field: optional chalk.container.v1.ContainerStatusReason status_reason = 9;
   */
  statusReason?: ContainerStatusReason;

  /**
   * Active group reservation being acknowledged; required for a group refund.
   *
   * @generated from field: optional string sandbox_group_reservation_id = 10;
   */
  sandboxGroupReservationId?: string;

  /**
   * True only after the controller establishes that execution has terminated.
   *
   * @generated from field: bool termination_confirmed = 11;
   */
  terminationConfirmed: boolean;
};

/**
 * Describes the message chalk.container.v1.UpdateContainerStatusRequest.
 * Use `create(UpdateContainerStatusRequestSchema)` to create a new message.
 */
export const UpdateContainerStatusRequestSchema: GenMessage<UpdateContainerStatusRequest> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 59);

/**
 * @generated from message chalk.container.v1.UpdateContainerStatusResponse
 */
export type UpdateContainerStatusResponse = Message<"chalk.container.v1.UpdateContainerStatusResponse"> & {
  /**
   * @generated from field: chalk.container.v1.ContainerResponse container = 1;
   */
  container?: ContainerResponse;
};

/**
 * Describes the message chalk.container.v1.UpdateContainerStatusResponse.
 * Use `create(UpdateContainerStatusResponseSchema)` to create a new message.
 */
export const UpdateContainerStatusResponseSchema: GenMessage<UpdateContainerStatusResponse> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 60);

/**
 * @generated from message chalk.container.v1.BatchUpdateContainerStatusRequest
 */
export type BatchUpdateContainerStatusRequest = Message<"chalk.container.v1.BatchUpdateContainerStatusRequest"> & {
  /**
   * @generated from field: repeated chalk.container.v1.UpdateContainerStatusRequest updates = 1;
   */
  updates: UpdateContainerStatusRequest[];
};

/**
 * Describes the message chalk.container.v1.BatchUpdateContainerStatusRequest.
 * Use `create(BatchUpdateContainerStatusRequestSchema)` to create a new message.
 */
export const BatchUpdateContainerStatusRequestSchema: GenMessage<BatchUpdateContainerStatusRequest> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 61);

/**
 * @generated from message chalk.container.v1.BatchUpdateContainerStatusResponse
 */
export type BatchUpdateContainerStatusResponse = Message<"chalk.container.v1.BatchUpdateContainerStatusResponse"> & {
};

/**
 * Describes the message chalk.container.v1.BatchUpdateContainerStatusResponse.
 * Use `create(BatchUpdateContainerStatusResponseSchema)` to create a new message.
 */
export const BatchUpdateContainerStatusResponseSchema: GenMessage<BatchUpdateContainerStatusResponse> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 62);

/**
 * GKEPodSnapshot captures GKE-specific pod snapshot configuration.
 * See https://docs.cloud.google.com/kubernetes-engine/docs/concepts/pod-snapshots
 *
 * @generated from message chalk.container.v1.GKEPodSnapshot
 */
export type GKEPodSnapshot = Message<"chalk.container.v1.GKEPodSnapshot"> & {
  /**
   * The GCS bucket where the snapshot is stored
   *
   * @generated from field: string storage_bucket = 1;
   */
  storageBucket: string;

  /**
   * The object path within the bucket
   *
   * @generated from field: string storage_path = 2;
   */
  storagePath: string;
};

/**
 * Describes the message chalk.container.v1.GKEPodSnapshot.
 * Use `create(GKEPodSnapshotSchema)` to create a new message.
 */
export const GKEPodSnapshotSchema: GenMessage<GKEPodSnapshot> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 63);

/**
 * ContainerSnapshotSpec is a oneof that contains the provider-specific snapshot details
 *
 * @generated from message chalk.container.v1.ContainerSnapshotSpec
 */
export type ContainerSnapshotSpec = Message<"chalk.container.v1.ContainerSnapshotSpec"> & {
  /**
   * @generated from oneof chalk.container.v1.ContainerSnapshotSpec.spec
   */
  spec: {
    /**
     * @generated from field: chalk.container.v1.GKEPodSnapshot gke_pod_snapshot = 1;
     */
    value: GKEPodSnapshot;
    case: "gkePodSnapshot";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.container.v1.ContainerSnapshotSpec.
 * Use `create(ContainerSnapshotSpecSchema)` to create a new message.
 */
export const ContainerSnapshotSpecSchema: GenMessage<ContainerSnapshotSpec> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 64);

/**
 * ContainerSnapshot represents a point-in-time snapshot of a container
 *
 * @generated from message chalk.container.v1.ContainerSnapshot
 */
export type ContainerSnapshot = Message<"chalk.container.v1.ContainerSnapshot"> & {
  /**
   * Unique snapshot ID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The ID of the source container that was snapshotted
   *
   * @generated from field: string source_container_id = 2;
   */
  sourceContainerId: string;

  /**
   * The spec of the source container at the time of the snapshot
   *
   * @generated from field: chalk.container.v1.ChalkContainerSpec container_spec = 3;
   */
  containerSpec?: ChalkContainerSpec;

  /**
   * Provider-specific snapshot configuration
   *
   * @generated from field: chalk.container.v1.ContainerSnapshotSpec snapshot_spec = 4;
   */
  snapshotSpec?: ContainerSnapshotSpec;

  /**
   * Snapshot status: Pending, InProgress, Completed, Failed
   *
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * Optional status message with more details
   *
   * @generated from field: optional string status_message = 6;
   */
  statusMessage?: string;

  /**
   * When the snapshot was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * When the snapshot completed (if completed)
   *
   * @generated from field: optional google.protobuf.Timestamp completed_at = 8;
   */
  completedAt?: Timestamp;

  /**
   * Who created the snapshot
   *
   * @generated from field: optional string created_by = 9;
   */
  createdBy?: string;
};

/**
 * Describes the message chalk.container.v1.ContainerSnapshot.
 * Use `create(ContainerSnapshotSchema)` to create a new message.
 */
export const ContainerSnapshotSchema: GenMessage<ContainerSnapshot> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 65);

/**
 * @generated from message chalk.container.v1.SnapshotContainerRequest
 */
export type SnapshotContainerRequest = Message<"chalk.container.v1.SnapshotContainerRequest"> & {
  /**
   * The container ID to snapshot (either id or name must be provided)
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * The container name to snapshot (either id or name must be provided)
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;
};

/**
 * Describes the message chalk.container.v1.SnapshotContainerRequest.
 * Use `create(SnapshotContainerRequestSchema)` to create a new message.
 */
export const SnapshotContainerRequestSchema: GenMessage<SnapshotContainerRequest> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 66);

/**
 * @generated from message chalk.container.v1.SnapshotContainerResponse
 */
export type SnapshotContainerResponse = Message<"chalk.container.v1.SnapshotContainerResponse"> & {
  /**
   * @generated from field: chalk.container.v1.ContainerSnapshot snapshot = 1;
   */
  snapshot?: ContainerSnapshot;
};

/**
 * Describes the message chalk.container.v1.SnapshotContainerResponse.
 * Use `create(SnapshotContainerResponseSchema)` to create a new message.
 */
export const SnapshotContainerResponseSchema: GenMessage<SnapshotContainerResponse> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 67);

/**
 * @generated from message chalk.container.v1.GetContainerSnapshotRequest
 */
export type GetContainerSnapshotRequest = Message<"chalk.container.v1.GetContainerSnapshotRequest"> & {
  /**
   * The snapshot ID to retrieve
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.container.v1.GetContainerSnapshotRequest.
 * Use `create(GetContainerSnapshotRequestSchema)` to create a new message.
 */
export const GetContainerSnapshotRequestSchema: GenMessage<GetContainerSnapshotRequest> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 68);

/**
 * @generated from message chalk.container.v1.GetContainerSnapshotResponse
 */
export type GetContainerSnapshotResponse = Message<"chalk.container.v1.GetContainerSnapshotResponse"> & {
  /**
   * @generated from field: chalk.container.v1.ContainerSnapshot snapshot = 1;
   */
  snapshot?: ContainerSnapshot;
};

/**
 * Describes the message chalk.container.v1.GetContainerSnapshotResponse.
 * Use `create(GetContainerSnapshotResponseSchema)` to create a new message.
 */
export const GetContainerSnapshotResponseSchema: GenMessage<GetContainerSnapshotResponse> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 69);

/**
 * @generated from message chalk.container.v1.ListContainerSnapshotsRequest
 */
export type ListContainerSnapshotsRequest = Message<"chalk.container.v1.ListContainerSnapshotsRequest"> & {
  /**
   * Optional: filter by source container ID
   *
   * @generated from field: optional string source_container_id = 1;
   */
  sourceContainerId?: string;

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message chalk.container.v1.ListContainerSnapshotsRequest.
 * Use `create(ListContainerSnapshotsRequestSchema)` to create a new message.
 */
export const ListContainerSnapshotsRequestSchema: GenMessage<ListContainerSnapshotsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 70);

/**
 * @generated from message chalk.container.v1.ListContainerSnapshotsResponse
 */
export type ListContainerSnapshotsResponse = Message<"chalk.container.v1.ListContainerSnapshotsResponse"> & {
  /**
   * @generated from field: repeated chalk.container.v1.ContainerSnapshot snapshots = 1;
   */
  snapshots: ContainerSnapshot[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.container.v1.ListContainerSnapshotsResponse.
 * Use `create(ListContainerSnapshotsResponseSchema)` to create a new message.
 */
export const ListContainerSnapshotsResponseSchema: GenMessage<ListContainerSnapshotsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 71);

/**
 * Message containing TTY input data (stdin) for container debug sessions
 *
 * @generated from message chalk.container.v1.ContainerTTYInput
 */
export type ContainerTTYInput = Message<"chalk.container.v1.ContainerTTYInput"> & {
  /**
   * Raw bytes to send to stdin
   *
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * Terminal resize information
   *
   * @generated from field: optional chalk.container.v1.ContainerTerminalSize resize = 2;
   */
  resize?: ContainerTerminalSize;
};

/**
 * Describes the message chalk.container.v1.ContainerTTYInput.
 * Use `create(ContainerTTYInputSchema)` to create a new message.
 */
export const ContainerTTYInputSchema: GenMessage<ContainerTTYInput> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 72);

/**
 * Terminal size information for resize events
 *
 * @generated from message chalk.container.v1.ContainerTerminalSize
 */
export type ContainerTerminalSize = Message<"chalk.container.v1.ContainerTerminalSize"> & {
  /**
   * @generated from field: uint32 rows = 1;
   */
  rows: number;

  /**
   * @generated from field: uint32 cols = 2;
   */
  cols: number;
};

/**
 * Describes the message chalk.container.v1.ContainerTerminalSize.
 * Use `create(ContainerTerminalSizeSchema)` to create a new message.
 */
export const ContainerTerminalSizeSchema: GenMessage<ContainerTerminalSize> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 73);

/**
 * Streaming request for container debug TTY session
 * First message must be init_request with session configuration
 * Subsequent messages are input with stdin data
 *
 * @generated from message chalk.container.v1.CreateContainerDebugTTYRequest
 */
export type CreateContainerDebugTTYRequest = Message<"chalk.container.v1.CreateContainerDebugTTYRequest"> & {
  /**
   * @generated from oneof chalk.container.v1.CreateContainerDebugTTYRequest.message
   */
  message: {
    /**
     * Initial request to create the TTY session
     *
     * @generated from field: chalk.container.v1.ContainerDebugTTYInitRequest init_request = 1;
     */
    value: ContainerDebugTTYInitRequest;
    case: "initRequest";
  } | {
    /**
     * Input data to send to the TTY
     *
     * @generated from field: chalk.container.v1.ContainerTTYInput input = 2;
     */
    value: ContainerTTYInput;
    case: "input";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.container.v1.CreateContainerDebugTTYRequest.
 * Use `create(CreateContainerDebugTTYRequestSchema)` to create a new message.
 */
export const CreateContainerDebugTTYRequestSchema: GenMessage<CreateContainerDebugTTYRequest> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 74);

/**
 * Initial configuration for creating a container debug TTY session
 *
 * @generated from message chalk.container.v1.ContainerDebugTTYInitRequest
 */
export type ContainerDebugTTYInitRequest = Message<"chalk.container.v1.ContainerDebugTTYInitRequest"> & {
  /**
   * The container ID to exec into (either id or name must be provided)
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * The container name to exec into (either id or name must be provided)
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * Optional: The command to execute
   * If not specified, defaults to ["/bin/sh"]
   *
   * @generated from field: repeated string command = 3;
   */
  command: string[];
};

/**
 * Describes the message chalk.container.v1.ContainerDebugTTYInitRequest.
 * Use `create(ContainerDebugTTYInitRequestSchema)` to create a new message.
 */
export const ContainerDebugTTYInitRequestSchema: GenMessage<ContainerDebugTTYInitRequest> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 75);

/**
 * Streaming response from container debug TTY session
 *
 * @generated from message chalk.container.v1.CreateContainerDebugTTYResponse
 */
export type CreateContainerDebugTTYResponse = Message<"chalk.container.v1.CreateContainerDebugTTYResponse"> & {
  /**
   * Raw bytes from stdout/stderr
   *
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * Error message if the session failed
   *
   * @generated from field: optional string error = 2;
   */
  error?: string;

  /**
   * Session closed indicator
   *
   * @generated from field: bool closed = 3;
   */
  closed: boolean;
};

/**
 * Describes the message chalk.container.v1.CreateContainerDebugTTYResponse.
 * Use `create(CreateContainerDebugTTYResponseSchema)` to create a new message.
 */
export const CreateContainerDebugTTYResponseSchema: GenMessage<CreateContainerDebugTTYResponse> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 76);

/**
 * @generated from message chalk.container.v1.WorkloadPrincipalIdentity
 */
export type WorkloadPrincipalIdentity = Message<"chalk.container.v1.WorkloadPrincipalIdentity"> & {
  /**
   * @generated from field: repeated chalk.auth.v1.Permission permissions = 1;
   */
  permissions: Permission[];

  /**
   * These fields are derived by the server from the creating principal and
   * persisted as immutable environment-scoped authorization policy.
   *
   * @generated from field: chalk.auth.v1.FeaturePermissions feature_permissions = 2;
   */
  featurePermissions?: FeaturePermissions;

  /**
   * @generated from field: repeated chalk.auth.v1.CustomClaim customer_claims = 3;
   */
  customerClaims: CustomClaim[];
};

/**
 * Describes the message chalk.container.v1.WorkloadPrincipalIdentity.
 * Use `create(WorkloadPrincipalIdentitySchema)` to create a new message.
 */
export const WorkloadPrincipalIdentitySchema: GenMessage<WorkloadPrincipalIdentity> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 77);

/**
 * @generated from message chalk.container.v1.SandboxGroupLimits
 */
export type SandboxGroupLimits = Message<"chalk.container.v1.SandboxGroupLimits"> & {
  /**
   * The root sandbox is not an active descendant.
   *
   * @generated from field: optional uint32 max_active_descendants = 1;
   */
  maxActiveDescendants?: number;

  /**
   * Aggregate CPU and memory ceilings include the root and use the same
   * quantity syntax as a sandbox's ResourceLimits. GPU group accounting is not
   * yet supported.
   *
   * @generated from field: chalk.container.v1.ResourceLimits resources = 2;
   */
  resources?: ResourceLimits;

  /**
   * Absolute group deadline, independent of every member sandbox's lifetime.
   * The controller enforces this deadline; controller outages can delay termination.
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp;

  /**
   * Immutable ceiling for every member's OIDC audience authority. Unset means any.
   *
   * @generated from field: chalk.container.v1.OIDCAudiencePolicy oidc_audience_policy = 4;
   */
  oidcAudiencePolicy?: OIDCAudiencePolicy;
};

/**
 * Describes the message chalk.container.v1.SandboxGroupLimits.
 * Use `create(SandboxGroupLimitsSchema)` to create a new message.
 */
export const SandboxGroupLimitsSchema: GenMessage<SandboxGroupLimits> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 78);

/**
 * OIDCAudiencePolicy is independent of automatic token-file delivery.
 *
 * @generated from message chalk.container.v1.OIDCAudiencePolicy
 */
export type OIDCAudiencePolicy = Message<"chalk.container.v1.OIDCAudiencePolicy"> & {
  /**
   * @generated from oneof chalk.container.v1.OIDCAudiencePolicy.policy
   */
  policy: {
    /**
     * @generated from field: google.protobuf.Empty any = 1;
     */
    value: Empty;
    case: "any";
  } | {
    /**
     * @generated from field: chalk.container.v1.OIDCAudienceSet only = 2;
     */
    value: OIDCAudienceSet;
    case: "only";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.container.v1.OIDCAudiencePolicy.
 * Use `create(OIDCAudiencePolicySchema)` to create a new message.
 */
export const OIDCAudiencePolicySchema: GenMessage<OIDCAudiencePolicy> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 79);

/**
 * @generated from message chalk.container.v1.OIDCAudienceSet
 */
export type OIDCAudienceSet = Message<"chalk.container.v1.OIDCAudienceSet"> & {
  /**
   * An empty set permits no OIDC token issuance.
   *
   * @generated from field: repeated string audiences = 1;
   */
  audiences: string[];
};

/**
 * Describes the message chalk.container.v1.OIDCAudienceSet.
 * Use `create(OIDCAudienceSetSchema)` to create a new message.
 */
export const OIDCAudienceSetSchema: GenMessage<OIDCAudienceSet> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 80);

/**
 * ChalkWorkloadIdentity configures managed Chalk authentication for a workload.
 *
 * @generated from message chalk.container.v1.ChalkWorkloadIdentity
 */
export type ChalkWorkloadIdentity = Message<"chalk.container.v1.ChalkWorkloadIdentity"> & {
  /**
   * @generated from field: chalk.container.v1.IdentityMode mode = 1;
   */
  mode: IdentityMode;

  /**
   * @generated from field: chalk.container.v1.WorkloadPrincipalIdentity workload_principal = 2;
   */
  workloadPrincipal?: WorkloadPrincipalIdentity;

  /**
   * OIDC tokens the platform materializes as files and keeps fresh for the
   * workload's lifetime. Requires IDENTITY_MODE_WORKLOAD_PRINCIPAL and is
   * supported for sandboxes only.
   *
   * @generated from field: repeated chalk.container.v1.OIDCTokenFile oidc_token_files = 3;
   */
  oidcTokenFiles: OIDCTokenFile[];

  /**
   * Effective issuance authority. Roots default to Only(the declared token-file
   * audiences), including an empty set when no files are declared. Children
   * default to their parent's effective policy. Explicit policies must fit the group ceiling.
   *
   * @generated from field: chalk.container.v1.OIDCAudiencePolicy oidc_audience_policy = 4;
   */
  oidcAudiencePolicy?: OIDCAudiencePolicy;

  /**
   * Immutable workload grants emitted in working JWTs as chalk.ai.user_provided/<key>.
   * Children may retain a subset of entries with identical values.
   *
   * @generated from field: map<string, string> user_provided_claims = 5;
   */
  userProvidedClaims: { [key: string]: string };
};

/**
 * Describes the message chalk.container.v1.ChalkWorkloadIdentity.
 * Use `create(ChalkWorkloadIdentitySchema)` to create a new message.
 */
export const ChalkWorkloadIdentitySchema: GenMessage<ChalkWorkloadIdentity> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 81);

/**
 * OIDCTokenFile declares an OIDC token for one audience that the platform
 * writes to a file and rotates. The workload reads the file path from env_var.
 *
 * @generated from message chalk.container.v1.OIDCTokenFile
 */
export type OIDCTokenFile = Message<"chalk.container.v1.OIDCTokenFile"> & {
  /**
   * Audience claim of the token, for example "snowflakecomputing.com".
   *
   * @generated from field: string audience = 1;
   */
  audience: string;

  /**
   * Environment variable that receives the absolute path of the token file.
   *
   * @generated from field: string env_var = 2;
   */
  envVar: string;
};

/**
 * Describes the message chalk.container.v1.OIDCTokenFile.
 * Use `create(OIDCTokenFileSchema)` to create a new message.
 */
export const OIDCTokenFileSchema: GenMessage<OIDCTokenFile> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 82);

/**
 * @generated from message chalk.container.v1.HostPlacementOptions
 */
export type HostPlacementOptions = Message<"chalk.container.v1.HostPlacementOptions"> & {
  /**
   * Restricts placement to a specific host pool.
   *
   * @generated from field: optional string host_pool_id = 1;
   */
  hostPoolId?: string;
};

/**
 * Describes the message chalk.container.v1.HostPlacementOptions.
 * Use `create(HostPlacementOptionsSchema)` to create a new message.
 */
export const HostPlacementOptionsSchema: GenMessage<HostPlacementOptions> = /*@__PURE__*/
  messageDesc(file_chalk_container_v1_service, 83);

/**
 * @generated from enum chalk.container.v1.Runtime
 */
export enum Runtime {
  /**
   * @generated from enum value: RUNTIME_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RUNTIME_GVISOR = 1;
   */
  GVISOR = 1,

  /**
   * @generated from enum value: RUNTIME_VM = 2;
   */
  VM = 2,

  /**
   * @generated from enum value: RUNTIME_RUNC = 3;
   */
  RUNC = 3,
}

/**
 * Describes the enum chalk.container.v1.Runtime.
 */
export const RuntimeSchema: GenEnum<Runtime> = /*@__PURE__*/
  enumDesc(file_chalk_container_v1_service, 0);

/**
 * @generated from enum chalk.container.v1.ExecutionBackend
 */
export enum ExecutionBackend {
  /**
   * @generated from enum value: EXECUTION_BACKEND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EXECUTION_BACKEND_ENVIRONMENT = 1;
   */
  ENVIRONMENT = 1,

  /**
   * @generated from enum value: EXECUTION_BACKEND_SERVERLESS = 2;
   */
  SERVERLESS = 2,
}

/**
 * Describes the enum chalk.container.v1.ExecutionBackend.
 */
export const ExecutionBackendSchema: GenEnum<ExecutionBackend> = /*@__PURE__*/
  enumDesc(file_chalk_container_v1_service, 1);

/**
 * @generated from enum chalk.container.v1.ResourceDetector
 */
export enum ResourceDetector {
  /**
   * @generated from enum value: RESOURCE_DETECTOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESOURCE_DETECTOR_GITHUB_PULL_REQUESTS = 1;
   */
  GITHUB_PULL_REQUESTS = 1,
}

/**
 * Describes the enum chalk.container.v1.ResourceDetector.
 */
export const ResourceDetectorSchema: GenEnum<ResourceDetector> = /*@__PURE__*/
  enumDesc(file_chalk_container_v1_service, 2);

/**
 * @generated from enum chalk.container.v1.ComputeClass
 */
export enum ComputeClass {
  /**
   * @generated from enum value: COMPUTE_CLASS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COMPUTE_CLASS_K8S = 1;
   */
  K8S = 1,

  /**
   * @generated from enum value: COMPUTE_CLASS_HOST = 2;
   */
  HOST = 2,
}

/**
 * Describes the enum chalk.container.v1.ComputeClass.
 */
export const ComputeClassSchema: GenEnum<ComputeClass> = /*@__PURE__*/
  enumDesc(file_chalk_container_v1_service, 3);

/**
 * @generated from enum chalk.container.v1.RestartPolicy
 */
export enum RestartPolicy {
  /**
   * @generated from enum value: RESTART_POLICY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESTART_POLICY_NEVER = 1;
   */
  NEVER = 1,

  /**
   * @generated from enum value: RESTART_POLICY_ALWAYS = 2;
   */
  ALWAYS = 2,
}

/**
 * Describes the enum chalk.container.v1.RestartPolicy.
 */
export const RestartPolicySchema: GenEnum<RestartPolicy> = /*@__PURE__*/
  enumDesc(file_chalk_container_v1_service, 4);

/**
 * @generated from enum chalk.container.v1.KernelPolicy
 */
export enum KernelPolicy {
  /**
   * @generated from enum value: KERNEL_POLICY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: KERNEL_POLICY_RESTRICTED = 1;
   */
  RESTRICTED = 1,

  /**
   * @generated from enum value: KERNEL_POLICY_OPEN = 2;
   */
  OPEN = 2,
}

/**
 * Describes the enum chalk.container.v1.KernelPolicy.
 */
export const KernelPolicySchema: GenEnum<KernelPolicy> = /*@__PURE__*/
  enumDesc(file_chalk_container_v1_service, 5);

/**
 * @generated from enum chalk.container.v1.ContainerStatusReason
 */
export enum ContainerStatusReason {
  /**
   * @generated from enum value: CONTAINER_STATUS_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONTAINER_STATUS_REASON_OOM_KILLED = 1;
   */
  OOM_KILLED = 1,
}

/**
 * Describes the enum chalk.container.v1.ContainerStatusReason.
 */
export const ContainerStatusReasonSchema: GenEnum<ContainerStatusReason> = /*@__PURE__*/
  enumDesc(file_chalk_container_v1_service, 6);

/**
 * @generated from enum chalk.container.v1.ProcessState
 */
export enum ProcessState {
  /**
   * @generated from enum value: PROCESS_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROCESS_STATE_RUNNING = 1;
   */
  RUNNING = 1,

  /**
   * @generated from enum value: PROCESS_STATE_EXITED = 3;
   */
  EXITED = 3,

  /**
   * @generated from enum value: PROCESS_STATE_FAILED = 4;
   */
  FAILED = 4,

  /**
   * @generated from enum value: PROCESS_STATE_TIMED_OUT = 5;
   */
  TIMED_OUT = 5,
}

/**
 * Describes the enum chalk.container.v1.ProcessState.
 */
export const ProcessStateSchema: GenEnum<ProcessState> = /*@__PURE__*/
  enumDesc(file_chalk_container_v1_service, 7);

/**
 * @generated from enum chalk.container.v1.IdentityMode
 */
export enum IdentityMode {
  /**
   * Unset runs the workload as its creator.
   *
   * @generated from enum value: IDENTITY_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Explicitly run the workload as its creator.
   *
   * @generated from enum value: IDENTITY_MODE_CREATOR_IDENTITY = 1;
   */
  CREATOR_IDENTITY = 1,

  /**
   * Run the workload as its own principal.
   *
   * @generated from enum value: IDENTITY_MODE_WORKLOAD_PRINCIPAL = 2;
   */
  WORKLOAD_PRINCIPAL = 2,
}

/**
 * Describes the enum chalk.container.v1.IdentityMode.
 */
export const IdentityModeSchema: GenEnum<IdentityMode> = /*@__PURE__*/
  enumDesc(file_chalk_container_v1_service, 8);

/**
 * @generated from service chalk.container.v1.ContainerService
 */
export const ContainerService: GenService<{
  /**
   * RunContainer creates and runs a new container as a Kubernetes pod
   *
   * @generated from rpc chalk.container.v1.ContainerService.RunContainer
   */
  runContainer: {
    methodKind: "unary";
    input: typeof RunContainerRequestSchema;
    output: typeof RunContainerResponseSchema;
  },
  /**
   * StopContainer stops and deletes a running container
   *
   * @generated from rpc chalk.container.v1.ContainerService.StopContainer
   */
  stopContainer: {
    methodKind: "unary";
    input: typeof StopContainerRequestSchema;
    output: typeof StopContainerResponseSchema;
  },
  /**
   * GetContainer retrieves the status of a specific container
   *
   * @generated from rpc chalk.container.v1.ContainerService.GetContainer
   */
  getContainer: {
    methodKind: "unary";
    input: typeof GetContainerRequestSchema;
    output: typeof GetContainerResponseSchema;
  },
  /**
   * ListContainers lists all containers created by this service
   *
   * @generated from rpc chalk.container.v1.ContainerService.ListContainers
   */
  listContainers: {
    methodKind: "unary";
    input: typeof ListContainersRequestSchema;
    output: typeof ListContainersResponseSchema;
  },
  /**
   * ExecCommand executes a command in a running container
   *
   * @generated from rpc chalk.container.v1.ContainerService.ExecCommand
   */
  execCommand: {
    methodKind: "unary";
    input: typeof ExecCommandRequestSchema;
    output: typeof ExecCommandResponseSchema;
  },
  /**
   * Session establishes a bidirectional command session in a running container
   *
   * @generated from rpc chalk.container.v1.ContainerService.Session
   */
  session: {
    methodKind: "bidi_streaming";
    input: typeof SessionRequestSchema;
    output: typeof SessionResponseSchema;
  },
  /**
   * GetSession retrieves information about a command session
   *
   * @generated from rpc chalk.container.v1.ContainerService.GetSession
   */
  getSession: {
    methodKind: "unary";
    input: typeof GetSessionRequestSchema;
    output: typeof GetSessionResponseSchema;
  },
  /**
   * ListSessions lists command sessions for a container
   *
   * @generated from rpc chalk.container.v1.ContainerService.ListSessions
   */
  listSessions: {
    methodKind: "unary";
    input: typeof ListSessionsRequestSchema;
    output: typeof ListSessionsResponseSchema;
  },
  /**
   * UpdateContainerStatus updates container status from K8s controller
   * Deprecated: use BatchUpdateContainerStatus
   *
   * @generated from rpc chalk.container.v1.ContainerService.UpdateContainerStatus
   * @deprecated
   */
  updateContainerStatus: {
    methodKind: "unary";
    input: typeof UpdateContainerStatusRequestSchema;
    output: typeof UpdateContainerStatusResponseSchema;
  },
  /**
   * BatchUpdateContainerStatus updates status for multiple containers from the dataplane controller
   *
   * @generated from rpc chalk.container.v1.ContainerService.BatchUpdateContainerStatus
   */
  batchUpdateContainerStatus: {
    methodKind: "unary";
    input: typeof BatchUpdateContainerStatusRequestSchema;
    output: typeof BatchUpdateContainerStatusResponseSchema;
  },
  /**
   * SnapshotContainer creates a point-in-time snapshot of a running container
   *
   * @generated from rpc chalk.container.v1.ContainerService.SnapshotContainer
   */
  snapshotContainer: {
    methodKind: "unary";
    input: typeof SnapshotContainerRequestSchema;
    output: typeof SnapshotContainerResponseSchema;
  },
  /**
   * GetContainerSnapshot retrieves a specific container snapshot
   *
   * @generated from rpc chalk.container.v1.ContainerService.GetContainerSnapshot
   */
  getContainerSnapshot: {
    methodKind: "unary";
    input: typeof GetContainerSnapshotRequestSchema;
    output: typeof GetContainerSnapshotResponseSchema;
  },
  /**
   * ListContainerSnapshots lists container snapshots, optionally filtered by source container
   *
   * @generated from rpc chalk.container.v1.ContainerService.ListContainerSnapshots
   */
  listContainerSnapshots: {
    methodKind: "unary";
    input: typeof ListContainerSnapshotsRequestSchema;
    output: typeof ListContainerSnapshotsResponseSchema;
  },
  /**
   * CreateContainerDebugTTY establishes a bidirectional streaming TTY session to a container
   * The first request must contain init_request with container id or name
   * Subsequent requests contain input data to send to the TTY stdin
   * Responses contain output data from the TTY stdout/stderr
   *
   * @generated from rpc chalk.container.v1.ContainerService.CreateContainerDebugTTY
   */
  createContainerDebugTTY: {
    methodKind: "bidi_streaming";
    input: typeof CreateContainerDebugTTYRequestSchema;
    output: typeof CreateContainerDebugTTYResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_container_v1_service, 0);

